import { PaymentMethod } from "services/paymentMethods";
import { Radio, RadioGroup } from "@material-ui/core";
import { useStyles } from "./styles";
import { ReactNode, useState } from "react";
import classnames from "classnames";
import { PricingModelItem } from "../../../services/pricingModel/model";
import CheckoutSummary from "../CheckoutSummary";
import PaymentSucceedModal from "../AddNewPaymentMethod/PaymentSucceedModal";
import PaymentFailedModal from "../AddNewPaymentMethod/PaymentFailedModal";
import SubmitButton from "../SubmitButton";
import PaymentMethodIcons from "components/PaymentMethodIcons";
import styles from "./style.module.scss";
import { PurchaseResult } from "services/subscriptions";

type Props = {
  onSavedMethodPurchase: () => Promise<PurchaseResult>;
  paymentMethods: PaymentMethod[];
  pricingModelItem: PricingModelItem;
  onSuccess: () => void;
  purchasing: boolean;
  children?: ReactNode;
};

export default function ExistingPaymentMethods({
  onSavedMethodPurchase,
  paymentMethods,
  pricingModelItem,
  onSuccess,
  purchasing,
  children,
}: Props) {
  const [selected, setSelected] = useState<PaymentMethod>(paymentMethods[0]);
  const [showModalDialog, setShowModalDialog] = useState<PurchaseResult | null>(null);

  const hdOnChange = (evt: any) => {
    evt.preventDefault();

    const id = evt.target.value;
    const newSelection = paymentMethods.find(pm => pm.id === id);
    newSelection && setSelected(newSelection);
  };

  const hdOnSubmit = async (evt: any) => {
    evt.preventDefault();
    if (purchasing) {
      return;
    }
    const result = await onSavedMethodPurchase();
    if (result !== "failed_reload_on_close") {
      setShowModalDialog(result);
    }
  };

  return (
    <div>
      {showModalDialog === "success" && (
        <PaymentSucceedModal plan={pricingModelItem} onClose={onSuccess} />
      )}
      {showModalDialog === "failed" && (
        <PaymentFailedModal onClose={() => setShowModalDialog(null)} />
      )}
      <RadioGroup defaultValue={selected.id} value={selected.id} onChange={hdOnChange}>
        {paymentMethods.map(pm => (
          <PaymentMethodRow
            key={pm.id}
            paymentMethod={pm}
            isSelected={pm.id === selected.id}
          />
        ))}
      </RadioGroup>
      <CheckoutSummary pricingItem={pricingModelItem}>
        <SubmitButton
          hdSubmit={hdOnSubmit}
          processing={purchasing}
          type={pricingModelItem.purchase_student_type}
        />
        {children}
      </CheckoutSummary>
    </div>
  );
}

type PaymentMethodRowProps = {
  paymentMethod: PaymentMethod;
  isSelected: boolean;
};

function PaymentMethodRow({ paymentMethod, isSelected }: PaymentMethodRowProps) {
  const classes = useStyles();
  return (
    <div className={classnames(styles.methodRow, { active: isSelected })}>
      <div className={styles.methodLabel}>
        <PaymentMethodIcons
          className={styles.paymentMethodIcon}
          paymentMethod={paymentMethod}
        />
        <span>•••• •••• •••• {paymentMethod.card.last4}</span>
      </div>
      <Radio
        checked={isSelected}
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={<span className={`${classes.icon} ${classes.checkedIcon}`} />}
        icon={<span className={classes.icon} />}
      />
    </div>
  );
}
